import { render, staticRenderFns } from "./Weight.vue?vue&type=template&id=100c2762&"
import script from "./Weight.vue?vue&type=script&lang=js&"
export * from "./Weight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports